export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col justify-between bg-background-50 px-6 md:px-12 pt-20 pb-16 md:pb-24">
      <div className="w-full max-w-[1280px] mx-auto">
        <p className="text-sm font-medium uppercase tracking-[0.05em] text-foreground-900 font-label animate-fade-up">
          LURADOS DIGITAL d.o.o.
        </p>
      </div>

      <div className="w-full max-w-[1280px] mx-auto mt-16 md:mt-24">
        <h1 className="text-[clamp(48px,8vw,96px)] leading-[1.05] font-bold font-heading text-foreground-950 max-w-[860px] animate-fade-up-delay-1">
          Engineering the future
          <br />
          of iOS. Built to last,
          <br />
          designed to perform.
        </h1>
      </div>

      <div className="w-full max-w-[1280px] mx-auto mt-20 md:mt-28 flex flex-col md:flex-row gap-12 md:gap-[120px]">
        <div className="max-w-[360px] animate-fade-up-delay-2">
          <p className="text-base md:text-lg leading-relaxed text-foreground-700 font-body">
            We design and develop modern digital software solutions for the iOS platform and related technologies, with a relentless focus on scalability, maintainability, and long-term technical quality.
          </p>
        </div>
        <div className="max-w-[360px] md:mt-8 animate-fade-up-delay-3">
          <p className="text-base md:text-lg leading-relaxed text-foreground-700 font-body">
            Every system we build is crafted with usability and stability at its core, ensuring reliable performance that endures.
          </p>
        </div>
      </div>
    </section>
  );
}